import './user-block.scss';

jQuery(document).ready(function($){
  $('body').on('click keypress','.uib__informations', function(event) {
    event.preventDefault();
    $(this).parents('.user-information-block').toggleClass('active');
    $(this).attr('aria-expanded', event.target.ariaExpanded == "true" ? "false" : "true");
  });

  $(document).on('click focusin', function(event){
    const containerClasses = '#block-tink-userinformation, #block-tink-userinformation-fournisseur, #block-tink-userinformation-2';

    // if the target of the click isn't the container nor a descendant of the container
    if (!$(containerClasses).is(event.target) && $(event.target).parents(containerClasses).length === 0) {
      $('.user-information-block').removeClass('active');
      $('.user-information-block .uib__informations').attr('aria-expanded', false);
    }
  });
});
